function extractOptions(originalArray: any, subsetArray: any): any[] {
  const subsetIds = new Set(subsetArray?.map((feature: any) => feature?.option_id));

  const uniqueObjects = originalArray?.filter(
    (option: any) => !subsetIds.has(option?.id)
  );

  return uniqueObjects;
}

export default extractOptions;
